import { queryOptions } from "@tanstack/react-query";
import { POLL_MS, apiGet, apiPost, withQuery } from "@amber/ui";
import {
  accessChangedSchema,
  createdIdSchema,
  itemDetailSchema,
  itemsResponseSchema,
  revisionResultSchema,
  urlCheckSchema,
  type AddItemRequest,
  type ExcludeRequest,
  type ReconsiderRequest,
} from "../../contracts/index";
import { collectionKeys } from "./keys";
import type { BacklogSearch } from "../search";

export const itemsQuery = (params: BacklogSearch & { limit?: number }) =>
  queryOptions({
    queryKey: collectionKeys.items(params),
    queryFn: ({ signal }) =>
      apiGet(
        withQuery("/api/collection/items", {
          ...params,
          limit: params.limit === undefined ? undefined : String(params.limit),
        }),
        itemsResponseSchema,
        signal,
      ),
    refetchInterval: POLL_MS,
    placeholderData: (previous) => previous,
  });

export const itemQuery = (id: string) =>
  queryOptions({
    queryKey: collectionKeys.item(id),
    queryFn: ({ signal }) => apiGet(`/api/collection/items/${encodeURIComponent(id)}`, itemDetailSchema, signal),
    refetchInterval: POLL_MS,
  });

export const urlCheckQuery = (url: string) =>
  queryOptions({
    queryKey: collectionKeys.urlCheck(url),
    queryFn: ({ signal }) => apiGet(withQuery("/api/collection/url-check", { url }), urlCheckSchema, signal),
    staleTime: 5_000,
  });

export const collectionCommands = {
  add: (body: AddItemRequest, csrf: string | null) => apiPost("/api/collection/items", body, createdIdSchema, csrf),
  exclude: (id: string, body: ExcludeRequest, csrf: string | null) =>
    apiPost(`/api/collection/items/${encodeURIComponent(id)}/exclude`, body, revisionResultSchema, csrf),
  reconsider: (id: string, body: ReconsiderRequest, csrf: string | null) =>
    apiPost(`/api/collection/items/${encodeURIComponent(id)}/reconsider`, body, revisionResultSchema, csrf),
  changeAccess: (id: string, path: "delete" | "restrict" | "restore", body: { reason: string }, csrf: string | null) =>
    apiPost(`/api/collection/items/${encodeURIComponent(id)}/${path}`, body, accessChangedSchema, csrf),
};
